import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmThoughtsIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmThoughtsIcon = ({ className, ...props }: EmThoughtsIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_274_19359)">
      <path
        d="M20.7007 8.80515C21.0273 8.12796 21.2095 7.36999 21.2095 6.56734C21.2095 3.71421 18.8977 1.40249 16.0446 1.40249C15.376 1.40249 14.7366 1.5314 14.1488 1.76343C13.3977 1.10859 12.4129 0.704681 11.3438 0.704681C10.0376 0.704681 8.86883 1.28906 8.09539 2.19999C7.49383 1.87343 6.80633 1.68437 6.08446 1.68437C3.78133 1.70156 1.90789 3.55781 1.90789 5.86093C1.90789 6.72031 2.16571 7.52812 2.62977 8.19843C1.77039 8.88593 1.16883 9.89999 1.04852 11.0859C0.825082 13.3891 2.52664 15.4687 4.86414 15.6922C5.41414 15.7437 5.92977 15.6922 6.42821 15.5547C6.61727 17.3937 8.16414 18.8203 10.0548 18.8203C11.2579 18.8203 12.3235 18.2359 12.9766 17.3422C13.5954 17.8234 14.3688 18.1328 15.2282 18.1328C17.1188 18.1328 18.6829 16.6719 18.8204 14.8328C20.2813 14.1625 21.3126 12.6844 21.3126 10.9656C21.3126 10.1767 21.084 9.43249 20.7007 8.80515Z"
        fill="white"
        stroke="#343A40"
        strokeMiterlimit="10"
        strokeWidth="1.03125"
      />
      <path
        d="M6.5 10C6.77614 10 7 9.77614 7 9.5C7 9.22386 6.77614 9 6.5 9C6.22386 9 6 9.22386 6 9.5C6 9.77614 6.22386 10 6.5 10Z"
        fill="#343A40"
        stroke="#343A40"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.5 10C11.7761 10 12 9.77614 12 9.5C12 9.22386 11.7761 9 11.5 9C11.2239 9 11 9.22386 11 9.5C11 9.77614 11.2239 10 11.5 10Z"
        fill="#343A40"
        stroke="#343A40"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.5 10C16.7761 10 17 9.77614 17 9.5C17 9.22386 16.7761 9 16.5 9C16.2239 9 16 9.22386 16 9.5C16 9.77614 16.2239 10 16.5 10Z"
        fill="#343A40"
        stroke="#343A40"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M4.17658 16.7234C3.40314 16.6375 2.71564 17.2047 2.62971 17.9781C2.54377 18.7516 3.11096 19.4391 3.88439 19.5078C4.65783 19.5938 5.34533 19.0266 5.43127 18.2531C5.51721 17.4797 4.95002 16.7922 4.17658 16.7234Z"
        fill="white"
        stroke="#343A40"
        strokeMiterlimit="10"
        strokeWidth="0.773438"
      />
      <path
        d="M1.54694 19.6453C1.03132 19.5938 0.567255 19.9719 0.515692 20.4875C0.46413 21.0031 0.842255 21.45 1.35788 21.5016C1.8735 21.5531 2.33757 21.175 2.38913 20.6594C2.44069 20.1609 2.06257 19.6969 1.54694 19.6453Z"
        fill="white"
        stroke="#343A40"
        strokeMiterlimit="10"
        strokeWidth="0.773438"
      />
    </g>
    <defs>
      <clipPath id="clip0_274_19359">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmThoughtsIcon;
